import React from 'react';
import SearchBarHero from './SearchBarHero/SearchBarHero';
import SellingNumbers from './SellingNumbers/SellingNumbers';
import pastaHero from './pasta_gourmet.png'
import './heroSection.css';

const HeroSection = () => {
  
  return (
    <div className="hero-section__container">
      <div className="hero-image-container">
        <img src={pastaHero} className="hero-section__hero-image" alt="Home" />
      </div>
      <div className="hero-section__search-numbers-container">
          <SearchBarHero />
      </div>
    </div>
  );
};

export default HeroSection;
